export const formatClassNames = classNames => classNames.filter(Boolean).join(' ');
